// noinspection DuplicatedCode

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { useSnackbar } from 'notistack';
import { connect } from 'react-redux';
import TextField from '@/modules/common/components/TextField';
import DialogForm from '@/modules/common/components/DialogForm';
import { withFetch } from '~/hocs/fetch';
import { actionLogout } from '@/modules/application/actions/auth';

const initialValues = {
    password1: '',
    password2: '',
};

const initialErrors = {
    password1: '',
    password2: '',
};

let abortController;

const DialogChangePassword = (props) => {
    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState(initialErrors);
    const [fetching, setFetching] = useState(false);

    const { enqueueSnackbar } = useSnackbar();

    const clear = () => {
        setValues(initialValues);
        setErrors(initialErrors);
    };

    useEffect(() => {
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    const handleChange = (prop) => (event) => {
        setValues({...values, [prop]: event.target.value});
    };

    const handleFocus = (prop) => () => {
        setErrors({...errors, [prop]: ''});
    };

    const handleSubmit = (event) => {
        abortController = new AbortController();
        event.preventDefault();
        setFetching(true);
        props.fetch.post(`/api/users/${props.username}/change-password/`, values, abortController)
            .then(({ok, data}) => {
                if (ok) {
                    handleClose();
                    enqueueSnackbar('Пароль изменен', {variant: 'success'});
                    if (props.user.username === props.username) {
                        props.logout();
                    }
                }
                else {
                    let _errors = {...initialErrors};
                    _errors.password1 = (data.password1) ? data.password1[0] : '';
                    _errors.password2 = (data.password2) ? data.password2[0] : '';
                    setErrors(_errors);
                }
                setFetching(false);
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    setFetching(false);
                }
            })
            .finally(() => {
                abortController = null;
            });
    };

    const handleClose = () => {
        props.setOpen(false);
        clear();
        if (props.setSelected) {
            props.setSelected(null);
        }
    };

    return (
        <DialogForm title="Изменение пароля" label="Изменить"
                    open={props.open} onClose={handleClose}
                    onSubmit={handleSubmit}
                    disabled={fetching}
        >
            <TextField label="Пароль" type="password"
                       value={values.password1}
                       onChange={handleChange('password1')}
                       error={errors.password1.length > 0}
                       helperText={errors.password1}
                       onFocus={handleFocus('password1')}
                       autoFocus={true}
            />
            <TextField label="Повторите пароль" type="password"
                       value={values.password2}
                       onChange={handleChange('password2')}
                       error={errors.password2.length > 0}
                       helperText={errors.password2}
                       onFocus={handleFocus('password2')}
            />
        </DialogForm>
    );
};

DialogChangePassword.propTypes = {
    username: PropTypes.string,
    setSelected: PropTypes.func,
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
};

let Component = DialogChangePassword;
Component = withFetch(Component);

export default connect(
    (state) => ({
        user: state.auth.user,
    }),
    (dispatch) => ({
        logout: bindActionCreators(actionLogout, dispatch),
    })
)(Component);
